import React, { useState } from 'react';
import Navigation from './Navigation';

const BrowsePage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  products, 
  categories, 
  setSelectedProduct, 
  logout, 
  addToCart 
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         product.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = !selectedCategory || product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    setCurrentPage('productDetail');
  };

  const handleAddToCart = (product) => {
    addToCart(product);
    // Optional: Show a brief success message
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <p>Welcome back, {currentUser.username}!</p>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <div className="search-bar">
        <input
          type="text"
          placeholder="Search products by title or description..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select 
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
        <button onClick={() => {setSearchTerm(''); setSelectedCategory('');}}>
          Clear
        </button>
      </div>

      <h2>Available Products ({filteredProducts.length})</h2>
      
      {filteredProducts.length === 0 ? (
        <div className="form">
          <p>No products found matching your criteria.</p>
        </div>
      ) : (
        <div className="products-grid">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="img">📷 Image Placeholder</div>
              <h3>{product.title}</h3>
              <p className="price">${product.price}</p>
              <p><strong>Category:</strong> {product.category}</p>
              <p style={{fontSize: '14px', color: '#666', marginBottom: '10px'}}>
                {product.description.substring(0, 80)}...
              </p>
              <button onClick={() => handleViewDetails(product)}>
                View Details
              </button>
              <button onClick={() => handleAddToCart(product)}>
                Add to Cart
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BrowsePage;